<div class="fe-layer" id="_exportLayer">
    <div class="fe-layer-main">
        <div class="fe-layer-header">
            <span class="title">导出/参考文献（<span id="_currExportListCount">{{$data.count}}</span>）</span>
            <div class="select-export-format fe-form">
                <div class="form-group">
                    <select name="" id="_selectExportFormat" class="form-control">
                        <option value="">输出格式</option>
                        <option type="1">GB/T 7714-2015</option>
                        <option type="2">NoteExpress</option>
                        <option type="3">RefWorks</option>
                        <option type="4">NoteFirst</option>
                        <option type="5">EndNote</option>
                        <option type="6">Bibtex</option>
                        <option type="7">查新格式</option>
                    </select>
                </div>
            </div>
            <div class="delete-btn">
                <a href="javascript:;" title="关闭" role="button" class="iconfont close-layer-btn icon-guanbi3 _closeCurrLayerBtn"></a>
            </div>
        </div>
        <div class="fe-layer-content">
            <div class="list-content">
                <ul class="paper-list">
                    {{each $data.list}}
                    <li class="paper-item _paperItem" data-id="{{$value.id}}">
                        <p class="paper-item-desc">{{$value.desc}}</p>
                        <a href="javascript:;" role="button" class="_deleteCurrPaperItem delete-paper-item-btn">
                            <i class="iconfont icon-shanchu1 "></i>
                        </a>
                    </li>
                    {{/each}}
                </ul>
            </div>
        </div>
    </div>
</div>